<template>
  <div class="dashboard-container">
    <div class="dashboard-header">
      <h1 class="dashboard-title">平台管理 Dashboard</h1>
      <p class="dashboard-subtitle">歡迎回來，{{ (user && user.name) || (user && user.username) || '' }}</p>
    </div>

    <div class="dashboard-content">
      <div class="info-cards">
        <div class="info-card">
          <div class="info-card-icon" style="background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);">
            <i class="ri-building-line"></i>
          </div>
          <div class="info-card-content">
            <h3>平台名稱</h3>
            <p>{{ (user && user.platformName) || 'N/A' }}</p>
          </div>
        </div>

        <div class="info-card">
          <div class="info-card-icon" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
            <i class="ri-user-line"></i>
          </div>
          <div class="info-card-content">
            <h3>帳號類型</h3>
            <p>{{ (user && user.accountType) || 'platform' }}</p>
          </div>
        </div>

        <div class="info-card">
          <div class="info-card-icon" style="background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);">
            <i class="ri-checkbox-circle-line"></i>
          </div>
          <div class="info-card-content">
            <h3>有效客戶/上限</h3>
            <p>{{ stats.activeClientCount || 0 }}/{{ stats.maxClients !== null && stats.maxClients !== undefined ? stats.maxClients : '無限制' }}</p>
          </div>
        </div>

        <div class="info-card">
          <div class="info-card-icon" style="background: linear-gradient(135deg, #fbc531 0%, #f39c12 100%);">
            <i class="ri-pause-circle-line"></i>
          </div>
          <div class="info-card-content">
            <h3>暫停/停用客戶</h3>
            <p>暫停: {{ stats.suspendedClientCount || 0 }} / 停用: {{ stats.inactiveClientCount || 0 }}</p>
          </div>
        </div>
      </div>

      <div class="dashboard-section">
        <h2>快速功能</h2>
        <div class="quick-actions">
          <button class="quick-action-btn" @click="$router.push('/system/clients')">
            <i class="ri-group-line"></i>
            <span>客戶管理</span>
          </button>
          <button class="quick-action-btn" @click="$router.push('/platform/analytics')">
            <i class="ri-bar-chart-line"></i>
            <span>數據分析</span>
          </button>
          <button class="quick-action-btn" @click="$router.push('/system/subscription-clients')">
            <i class="ri-file-list-line"></i>
            <span>訂閱管理</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import authService from '@/helpers/authservice/authService.js';
import { platformAccountService } from '@/api/modules/platformAccounts.js';

export default {
  name: 'PlatformDashboard',
  setup() {
    const user = ref(null);
    const stats = ref({
      maxClients: null,
      activeClientCount: 0,
      suspendedClientCount: 0,
      inactiveClientCount: 0
    });
    const loading = ref(false);

    const fetchDashboardStats = async () => {
      try {
        loading.value = true;
        const response = await platformAccountService.getDashboardStats();
        console.log('[PlatformDashboard] API response:', response);
        if (response && response.success && response.data) {
          stats.value = {
            maxClients: response.data.maxClients,
            activeClientCount: response.data.activeClientCount,
            suspendedClientCount: response.data.suspendedClientCount,
            inactiveClientCount: response.data.inactiveClientCount
          };
          console.log('[PlatformDashboard] Stats updated:', stats.value);
        } else {
          console.warn('[PlatformDashboard] Invalid response format:', response);
        }
      } catch (error) {
        console.error('獲取平台統計資訊失敗:', error);
      } finally {
        loading.value = false;
      }
    };

    onMounted(() => {
      user.value = authService.getCurrentUser();
      fetchDashboardStats();
    });

    return {
      user,
      stats,
      loading,
    };
  },
};
</script>

<style scoped>
.dashboard-container {
  padding: 24px;
}

.dashboard-header {
  margin-bottom: 32px;
}

.dashboard-title {
  font-size: 32px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.dashboard-subtitle {
  font-size: 16px;
  color: #666;
}

.dashboard-content {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.info-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.info-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 20px;
}

.info-card-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
}

.info-card-content h3 {
  font-size: 14px;
  color: #666;
  margin-bottom: 4px;
  font-weight: 500;
}

.info-card-content p {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.dashboard-section {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.dashboard-section h2 {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
}

.quick-actions {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.quick-action-btn {
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: white;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.quick-action-btn:hover {
  border-color: #f5576c;
  background: #fff5f7;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(245, 87, 108, 0.2);
}

.quick-action-btn i {
  font-size: 32px;
  color: #f5576c;
}

.quick-action-btn span {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}
</style>
